const Logo = ({ variant, className }) => {
	return (
		<div className={`logo flex-row-left ${className || ""}`}>
			<div className="pisara-container bg-default">
				<div className={`pisara ${variant}`} />
			</div>
			<div className="logo-text-container">
				<span className="pisara-text upper text-medium-gotham block">
					Pisara
				</span>
				<span className="opacity-5 text-sm">Sentry Dashoboard</span>
			</div>
		</div>
	);
};

export default Logo;
